var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        [
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.mainTable.sarchCardShow
                ? _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("search-card", {
                            attrs: {
                              form: _vm.mainTable.searchForm,
                              "table-load-event": _vm.getSaleStatList,
                              "table-search": _vm.mainTable.tableSearch,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c(
                    "div",
                    { staticClass: "left-bar" },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("客户销售统计"),
                      ]),
                      _c("span", { staticStyle: { "margin-left": "20px" } }, [
                        _vm._v("统计时间:"),
                      ]),
                      _c("span", { staticStyle: { "margin-left": "20px" } }, [
                        _vm._v("会员类别:"),
                      ]),
                      _c(
                        "RadioGroup",
                        {
                          staticStyle: { "margin-left": "4px" },
                          on: { "on-change": _vm.onUserTypeChage },
                          model: {
                            value: _vm.userType,
                            callback: function ($$v) {
                              _vm.userType = $$v
                            },
                            expression: "userType",
                          },
                        },
                        [
                          _c("Radio", { attrs: { label: "F" } }, [
                            _c("span", [_vm._v("外部会员")]),
                          ]),
                          _c("Radio", { attrs: { label: "E" } }, [
                            _c("span", [_vm._v("内部会员")]),
                          ]),
                        ],
                        1
                      ),
                      _c("DatePicker", {
                        staticStyle: { "margin-left": "4px", width: "200px" },
                        attrs: {
                          type: "daterange",
                          size: "small",
                          transfer: "",
                          placement: "bottom-end",
                          placeholder: "选择期初和期末时间",
                        },
                        on: { "on-change": _vm.onDateChange },
                        model: {
                          value: _vm.selectDates,
                          callback: function ($$v) {
                            _vm.selectDates = $$v
                          },
                          expression: "selectDates",
                        },
                      }),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "warning",
                            size: "small",
                            shape: "circle",
                            icon: "ios-send",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showMonthlySale()
                            },
                          },
                        },
                        [_vm._v("每月销售")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "right-bar" },
                    [
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "info",
                            size: "small",
                            shape: "circle",
                            icon: "ios-send",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onExport()
                            },
                          },
                        },
                        [_vm._v("导出")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "primary",
                            size: "small",
                            shape: "circle",
                            icon: "ios-search",
                          },
                          on: {
                            click: function ($event) {
                              _vm.mainTable.sarchCardShow =
                                !_vm.mainTable.sarchCardShow
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    attrs: {
                      columns: _vm.mainTable.statColumns,
                      data: _vm.mainTable.data,
                      loading: _vm.mainTable.loading,
                      "table-search": _vm.mainTable.tableSearch,
                      extHeight: -50,
                      "table-load-event": _vm.getSaleStatList,
                      showPage: false,
                    },
                  }),
                ],
                1
              ),
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "formula-section" }, [
                  _c("h3", { staticClass: "formula-title" }, [
                    _c("div", { staticStyle: { "margin-right": "8px" } }, [
                      _vm._v("计算公式:"),
                    ]),
                  ]),
                  _c("div", { staticClass: "formula-item" }, [
                    _c("strong", [_vm._v("有效金额")]),
                    _vm._v(
                      " = 销售金额 - 优惠金额 - 代金券 -\n                        退货金额\n                    "
                    ),
                  ]),
                  _c("div", { staticClass: "formula-item" }, [
                    _c("strong", [_vm._v("净收入")]),
                    _vm._v(
                      " = 有效金额 + 收违约金 -\n                        客户经理提成 - IT/客服提成 - 种苗网基金 - 退款金额 -\n                        退纸箱费 - 退违约金\n                    "
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            title: "定金明细",
            width: 1200,
            closable: false,
            "footer-hide": "",
          },
          model: {
            value: _vm.depositDetail.show,
            callback: function ($$v) {
              _vm.$set(_vm.depositDetail, "show", $$v)
            },
            expression: "depositDetail.show",
          },
        },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "div",
                    { staticClass: "right-bar onExportDetails" },
                    [
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "info",
                            size: "small",
                            shape: "circle",
                            icon: "ios-send",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onDetailExport()
                            },
                          },
                        },
                        [_vm._v("导出")]
                      ),
                    ],
                    1
                  ),
                  _c("stand-pagination-table", {
                    attrs: {
                      columns: _vm.depositDetail.columns,
                      data: _vm.depositDetail.data,
                      loading: _vm.depositDetail.loading,
                      "table-search": _vm.depositDetail.tableSearch,
                      "table-load-event": _vm.showDepositDetail,
                      summaryLabelField: "depositBillRecordCode",
                      summaryFields: [
                        "liquidatedDamagesQuantity",
                        "totalOrderCost",
                      ],
                      autoHeight: true,
                      showPage: true,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "div-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "Button",
                {
                  staticClass: "btn-font",
                  attrs: { type: "text" },
                  on: { click: _vm.cancal },
                },
                [_vm._v("✕")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { width: 1000, "footer-hide": "" },
          model: {
            value: _vm.monthlySaleModal.show,
            callback: function ($$v) {
              _vm.$set(_vm.monthlySaleModal, "show", $$v)
            },
            expression: "monthlySaleModal.show",
          },
        },
        [
          _vm.monthlySaleModal.innerSpin
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "span",
                { staticStyle: { "font-weight": "bold", "font-size": "14px" } },
                [_vm._v("每月销售统计")]
              ),
              _c("DatePicker", {
                staticStyle: { width: "100px", "margin-left": "10px" },
                attrs: { type: "year", size: "small", placeholder: "选择年份" },
                on: { "on-change": _vm.onYearChange },
                model: {
                  value: _vm.monthlySaleModal.year,
                  callback: function ($$v) {
                    _vm.$set(_vm.monthlySaleModal, "year", $$v)
                  },
                  expression: "monthlySaleModal.year",
                },
              }),
            ],
            1
          ),
          _c("MonthlySaleBar", {
            ref: "monthlySaleBar",
            staticStyle: { height: "400px", width: "100%" },
            attrs: {
              value: _vm.monthlySaleModal.barData,
              text: _vm.monthlySaleModal.title,
            },
          }),
        ],
        1
      ),
      _c("PreSaleOrderDetail", { ref: "preSaleOrderDetailModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }